import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { SharedModule } from "../../shared.module";

@Component({
  selector: "vl-file-dropper",
  standalone: true,
  imports: [SharedModule],
  templateUrl: "./file-dropper.component.html",
  styleUrls: ["./file-dropper.component.scss"],
})
export class FileDropperComponent implements OnInit {
  @Output() output = new EventEmitter();

  ngOnInit() {}

  public changeListener(target: EventTarget) {
    const files = (target as any).files;
    if (files && files.length > 0) {
      let file: File = files.item(0);
      let reader: FileReader = new FileReader();
      reader.readAsText(file);
      reader.onload = (e) => {
        let csv: string = reader.result as string;
        this.read(csv);
      };
    }
  }

  read(csv: string) {
    var allTextLines = csv.split(/\r\n|\n/);
    var headers = allTextLines[0].split(";");
    var lines = [];
    var errors = [];

    for (var i = 1; i < allTextLines.length; i++) {
      var data;

      if (
        (allTextLines[i][0] === '"' || allTextLines[i][0] === "'") &&
        (allTextLines[i][allTextLines[i].length - 1] === '"' ||
          allTextLines[i][allTextLines[i].length - 1] === "'")
      ) {
        data = allTextLines[i].slice(1, allTextLines[i].length - 1).split(";");
      } else {
        data = allTextLines[i].split(";");
      }

      if (data.length === headers.length) {
        var tarr = [];
        for (var j = 0; j < headers.length; j++) {
          tarr.push(data[j] && data[j].trim() !== "" ? data[j] : null);
        }
        lines.push(tarr);
      } else {
        errors.push(data, i);
      }
    }

    this.output.emit(lines);
  }
}
